import { render, staticRenderFns } from "./footer_bar_m.vue?vue&type=template&id=72c65d12&scoped=true"
import script from "./footer_bar_m.vue?vue&type=script&lang=js"
export * from "./footer_bar_m.vue?vue&type=script&lang=js"
import style0 from "./footer_bar_m.vue?vue&type=style&index=0&id=72c65d12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c65d12",
  null
  
)

export default component.exports